<div class="management-table-container">
  <div class="action-bar">
    <div class="action-buttons-left"></div>
    <div class="action-buttons-right">
      <a class='kpi-button-menu' title="Save" (click)="onSave()" [class.disabled]="isSaving || isLoading">
        <mat-icon class="icon-color-fix">{{ isSaving ? 'hourglass_empty' : 'save' }}</mat-icon> Save
      </a>
    </div>
  </div>

  <div class="searchbar__search-bar">
    <mat-icon class="searchbar__search-icon">search</mat-icon>
    <input
      class="searchbar__search-input"
      type="text"
      placeholder="Search by ID or name..."
      [(ngModel)]="searchTerm"
      (input)="applySearch()" />
      @if (searchTerm) {
        <button mat-icon-button class="searchbar__search-clear"
          (click)="searchTerm = ''; applySearch()">
          <mat-icon>close</mat-icon>
        </button>
      }
    </div>

    <div class="mgmt-type-config__table-wrapper">
      @if (!isLoading) {
        <mat-table [dataSource]="dataSource" [trackBy]="trackByValue"
          class="mgmt-type-config__table mat-elevation-z2">
          <!-- Management Name Column -->
          <ng-container matColumnDef="groupName">
            <mat-header-cell *matHeaderCellDef>ManagementID</mat-header-cell>
            <mat-cell *matCellDef="let row">
              <span class="mgmt-type-config__name" [style.padding-left.px]="row.depth * 16">
                @if (row.hasChildren) {
                  <button mat-icon-button class="mgmt-type-config__expand-btn"
                    (click)="toggleExpand(row)">
                    <mat-icon>{{ row.expanded ? 'expand_more' : 'chevron_right' }}</mat-icon>
                  </button>
                }
                @if (!row.hasChildren) {
                  <span class="mgmt-type-config__expand-placeholder"></span>
                }
                {{ row.groupName }}
              </span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="typeSelection">
            <mat-header-cell *matHeaderCellDef class="mgmt-type-config__options-header">
              <span class="mgmt-type-config__toggle-label">FLD</span>
              <span class="mgmt-type-config__toggle-label">MFG</span>
              <span class="mgmt-type-config__toggle-label">R&amp;D</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
              @if (row.isSelectable) {
                <mat-button-toggle-group [(ngModel)]="row.selectedType"
                  [name]="'type-' + row.value" class="mgmt-type-config__toggle-group"
                  hideSingleSelectionIndicator="true">
                  <mat-button-toggle value="FLD"></mat-button-toggle>
                  <mat-button-toggle value="MFG"></mat-button-toggle>
                  <mat-button-toggle value="R&D"></mat-button-toggle>
                </mat-button-toggle-group>
              } @else {
              }
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="['groupName', 'typeSelection']"></mat-header-row>
          <mat-row *matRowDef="let row; columns: ['groupName', 'typeSelection']"
          [class.parent-row]="!row.isSelectable"></mat-row>
        </mat-table>
      }
    </div>

    <!-- Empty state -->
    @if (!isLoading && rows.length === 0) {
      <div class="mgmt-type-config__empty">
        No management nodes found.
      </div>
    }
  </div>